<template>
  <div>
    <v-simple-table dense class="custm_table_padding bordered--table" v-if="turnoverDataList" :style="`width:${isAllCollapsed ? 45 : 100}%`">
      <template v-slot:default>
        <thead>
          <tr>
            <th style="width:0px;" v-if="showMonth"></th>
            <th class="custom_header_color" :class="groupByCustomer && !groupByViewEnabled && index === 0 ? 'text-left' : 'text-right'"
              v-for="(head, index) in headers" :key="index">{{ $t(head) }}</th>
            <template v-if="!isAllCollapsed">
              <th v-for="(i, index) in 8" :key="`other_${index}`"></th>
              <th v-if="groupByCustomer && groupByViewEnabled"></th>
            </template>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in turnoverDataList">
            <template v-if="groupByCustomer && !groupByViewEnabled">
              <tr :key="`customer_${index}`">
                <td class="pa-0">
                  {{ item.customername }}
                </td>
                <td class="pa-0 text-right">
                  {{ item.total | replaceDotWithComma }}
                </td>
              </tr>
            </template>
            <tr v-else :key="`year_${index}`">
              <td class="pa-0" v-if="showMonth">
                <v-btn icon small @click="toggleExpand(index)">
                  <v-icon v-if="item.toggle_show">mdi-arrow-up-drop-circle-outline</v-icon>
                  <v-icon v-else>mdi-arrow-down-drop-circle-outline</v-icon>
                </v-btn>
              </td>
              <td v-if="groupByCustomer && groupByViewEnabled"></td>
              <td class="text-right custom_cell_color">{{ item.year }}</td>
              <td class="text-right custom_cell_color">{{ item.turnover | replaceDotWithComma }}</td>
              <td class="text-right custom_cell_color">{{ item.totalcost | replaceDotWithComma }}</td>
              <td class="text-right custom_cell_color">{{ item.averagedg | replaceDotWithComma }}</td>
              <template v-if="!isAllCollapsed">
                <td v-for="i in 8" :key="`emptycells_${i}`"></td>
                <td v-if="groupByCustomer && groupByViewEnabled"></td>
              </template>
            </tr>
            <tr v-if="item.expanded" :key="`monthsnameslist_${index}`">
              <td v-if="showMonth"></td>
              <td v-if="groupByCustomer && groupByViewEnabled">{{ $t('message.order.customer') }}</td>
              <td class="text-right custom_header_color" v-for="(month, index) in monthsName" :key="index">{{ month }}</td>
              <td class="text-right" v-if="groupByCustomer && groupByViewEnabled">{{ $t('message.common.total') }}</td>
            </tr>
            <template v-if="item.expanded">
              <!-- group by both customer & month/year -->
              <template v-if="groupByCustomer && groupByViewEnabled">
                <template v-for="(customer, customerIndex) in item.resultspercustomer">
                  <tr :key="`customer_${customerIndex}_${customer.total}`">
                    <td></td>
                    <td>{{ customer.customername }}</td>
                    <template v-if="visibleMonthsInYears">
                      <td class="text-right custom_cell_color" v-for="(value, index) in customer.resultspermonth" :key="`value_${index}`">
                        {{ visibleMonthsInYears[item.year].includes(index+1) ? value : '' | replaceDotWithComma }}
                      </td>
                      <td class="text-right custom_cell_color">{{ getTotal(customer.resultspermonth) | replaceDotWithComma }}</td>
                    </template>
                    <template v-else>
                      <td class="text-right custom_cell_color" v-for="(value, index) in item.resultspermonth" :key="index">{{ value | replaceDotWithComma }}</td>
                    </template>
                  </tr>
                  <tr v-if="(item.resultspercustomer.length - 1) === customerIndex" :key="`total_${customerIndex}_${customer.total}`">
                    <td></td>
                    <td>{{ $t('message.common.total') }}</td>
                    <td class="text-right custom_cell_color font-weight-bold" v-for="(value, index) in customer.resultspermonth" :key="index">
                      {{ getTotalForAll(item.resultspercustomer, index) | replaceDotWithComma }}
                    </td>
                    <td class="text-right custom_cell_color font-weight-bold">
                      {{ getTotalForAll(item.resultspercustomer) | replaceDotWithComma }}
                    </td>
                  </tr>
                </template>
              </template>
              <!-- when customer is removed from the filter -->
              <template v-else>
                <tr :key="`monthsvalueslist_${index}`">
                  <td></td>
                  <template v-if="visibleMonthsInYears">
                    <td class="text-right custom_cell_color" v-for="(value, index) in item.resultspermonth" :key="`value_${index}`">
                      {{ visibleMonthsInYears[item.year].includes(index+1) ? value : '' | replaceDotWithComma }}
                    </td>
                  </template>
                  <template v-else>
                    <td class="text-right custom_cell_color" v-for="(value, index) in item.resultspermonth" :key="index">{{ value | replaceDotWithComma }}</td>
                  </template>
                </tr>
              </template>
            </template>
            <!-- Group by customer and year -->
            <template v-if="!showMonth && groupByCustomer && groupByViewEnabled">
              <tr :key="`head_${index}`">
                <td>{{ $t('message.order.customer') }}</td>
                <td class="text-right">{{ $t('message.common.total') }}</td>
                <td colspan="3"></td>
              </tr>
              <tr v-for="(customer, customerIndex) in item.resultspercustomer" :key="`customer_${customerIndex}_${customer.total}`">
                <td>{{ customer.customername }}</td>
                <template>
                  <td class="text-right custom_cell_color">
                    {{ customer.total | replaceDotWithComma }}
                  </td>
                  <td colspan="3"></td>
                </template>
              </tr>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: ['turnoverDataList', 'year', 'month', 'visibleMonthsInYears', 'groupByCustomer',
    'groupByViewEnabled'], // year and month are boolean values for condition to check
  data () {
    return {
      isAllCollapsed: true,
      showYear: this.year !== undefined ? this.year : true,
      showMonth: this.month !== undefined ? this.month : true
    }
  },
  computed: {
    monthsName () {
      let lang = this.$i18n.locale === 'en' ? 'en' : 'nb'
      let list = moment.localeData(lang).monthsShort()
      return list
    },
    headers () {
      if (this.groupByCustomer && !this.groupByViewEnabled) return ['message.order.customer', 'message.common.total']
      else {
        let listOfHeaders = ['message.datestrings.year', 'message.turnoverReport.turnover', 'message.document.cost', 'message.turnoverReport.dg']
        if (this.groupByCustomer && this.groupByViewEnabled) listOfHeaders.unshift('')
        return listOfHeaders
      }
    }
  },
  mounted () {
    if (this.turnoverDataList && !this.$formatter.isEmptyObject(this.turnoverDataList)) {
      this.isAllCollapsed = this.turnoverDataList.every(x => !x.expanded)
    } else this.isAllCollapsed = false
  },
  methods: {
    toggleExpand (index) {
      this.turnoverDataList[index].expanded = !this.turnoverDataList[index].expanded
      this.$set(this.turnoverDataList, index, this.turnoverDataList[index])
      this.isAllCollapsed = this.turnoverDataList.every(x => !x.expanded)
    },
    getVisibileMonthArray (year) {
      return this.visibleMonthsInYears.find(x => x.year === +year).months || []
    },
    getTotalForAll (items, index) {
      let getAllTotal = 0
      if (index >= 0) {
        items.map(x => {
          getAllTotal += x.resultspermonth[index]
        })
      } else {
        items.map(x => {
          getAllTotal += this.$_getSum(x.resultspermonth)
        })
      }
      return getAllTotal > 0 ? getAllTotal : ''
    },
    getTotal (items) {
      return this.$_getSum(items)
    }
  }
}
</script>
<style>
.custm_table_padding > div.v-data-table__wrapper th,
.custm_table_padding > div.v-data-table__wrapper td {
  padding: 0 4px !important;
}
.custom_header_color {
  color: rgba(0, 0, 0, 0.64) !important;
}
.custom_cell_color {
  color: rgba(0, 0, 0, 0.84) !important;
}
</style>
